import { Injectable, inject } from '@angular/core';
import { Zeroconf } from '@awesome-cordova-plugins/zeroconf/ngx';
import { Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { FeedbackService, MsgType } from './feedback.service';

@Injectable({
  providedIn: 'root'
})
export class ZeroconfService {
  private feedback = inject(FeedbackService);
  private zeroconf = inject(Zeroconf);
  private platform = inject(Platform);


  public zeroconfSever: {name?: string, domain?: string }[] = []
  
  public zeroConfSub: Subscription

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {  
  }    
   
  public subscribeZeroConf(){ 

    if(!this.platform.is("capacitor")) return

    this.zeroconf.registerAddressFamily = 'ipv4';
    this.zeroconf.watchAddressFamily = 'ipv4';

    this.zeroConfSub = this.zeroconf.watch('_Zeiterfassung._tcp.', 'local.').subscribe(result => {
      console.log(result);
      
      if(result.service.port != -1)
      if(result.service.txtRecord.domain){
        if(this.zeroconfSever.find(s => s.domain == result.service.txtRecord.domain))return 
        else{  
           this.zeroconfSever.push({  
            domain: result.service.txtRecord.domain, 
            name: result.service.txtRecord.name 
          }) 
        }     
      }   
    })     
  }   
 
  public unsubscribeZeroConf(){ 
    this.zeroconfSever = []
    this.zeroConfSub?.unsubscribe()
  }
  
}  
          